import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/Form';
import './Modal.css';

interface SessionConfirmModalProps {
  onContinue: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export function SessionConfirmModal({ onContinue, onCancel, isLoading }: SessionConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <div className="auth-modal" role="dialog" aria-modal="true">
      <div className="auth-modal__panel auth-modal__panel--centered">
        <span className="auth-modal__icon" aria-hidden="true">
          <AlertTriangle size={26} />
        </span>
        <h2 className="auth-modal__title">{t('sessionWarning.title')}</h2>
        <p className="auth-modal__text">{t('sessionWarning.description')}</p>
        <div className="auth-modal__actions">
          <Button type="button" variant="ghost" onClick={onCancel} disabled={isLoading}>
            {t('general.cancelButton')}
          </Button>
          <Button type="button" onClick={onContinue} isLoading={isLoading}>
            {t('sessionWarning.continueButton')}
          </Button>
        </div>
      </div>
    </div>
  );
}
